import TableText from "@/components/table/TableText";
import _ from 'lodash';
import moment from "moment";
import React from "react";
import { numConvert, calculation } from '@/method';

const totalIndex = [];


export const compute = (data, { data4_2_1 } = {}) => {
    const corresponding = {
        0: 3,
        1: 6,
        2: 10,
        3: 11,
        4: 14,
        5: 18,
        6: 22,
        7: 27,
    };

    Object.entries(corresponding).forEach(item => {
        data[item[0]].rn_forecast = _.get(data4_2_1, `${item[1]}.forecast_rn`, 0);
        data[item[0]].rn_budget = _.get(data4_2_1, `${item[1]}.budget_rn`, 0);
        data[item[0]].rn_actual = _.get(data4_2_1, `${item[1]}.actual_rn`, 0);

        data[item[0]].avg_forecast = _.get(data4_2_1, `${item[1]}.forecast_adr`, 0);
        data[item[0]].avg_budget = _.get(data4_2_1, `${item[1]}.budget_adr`, 0);
        data[item[0]].avg_actual = _.get(data4_2_1, `${item[1]}.actual_adr`, 0);

        data[item[0]].rev_forecast = _.get(data4_2_1, `${item[1]}.forecast_rev`, 0);
        data[item[0]].rev_budget = _.get(data4_2_1, `${item[1]}.budget_rev`, 0);
        data[item[0]].rev_actual = _.get(data4_2_1, `${item[1]}.actual_rev`, 0);
    });
    data.forEach((item, i) => {
        data[i].vsforecast = (item.rev_actual - item.rev_forecast).toFixed(2);
        data[i].vsbudget = (item.rev_actual - item.rev_budget).toFixed(2);
    });
    return data;
}

export const columns = (onChange, date, print) => {
    const month = moment(date).format('M');
    const sqlName = '_4_2_1_new_diff';
    return [
        {
            title: "No. 序号",
            align: "center",
            fixed: print ? false : "left",
            width: 300,
            children: [{
                title: <div>主要市场细分 Key Market Segments</div>,
                dataIndex: 'name',
                key: 'name',
                align: "center",
                fixed: print ? false : "left",
                width: 300,
                render: (text, record, index) => {
                    const props = {
                        text,
                        index,
                        type: 'text',
                        name: "name",
                        onChange,
                        totalIndex,
                        compared: {
                            title: ['No. 序号', `主要市场细分<br />Key Market Segments`],
                            record,
                            sqlName
                        }
                    };
                    return <TableText data={props} />
                }
            },]
        },
        {
            title: `Room Nights 间夜数`,
            children: [{
                title: `${month}月(预测)`,
                dataIndex: 'rn_forecast',
                key: 'rn_forecast',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "rn_forecast",
                        onChange,
                        totalIndex,
                        compared: {
                            title: ['Room Nights 间夜数', `预测`],
                            record,
                            sqlName
                        }
                    };
                    return <TableText data={props} />
                }
            }, {
                title: `${month}月(预算)`,
                dataIndex: 'rn_budget',
                key: 'rn_budget',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "rn_budget",
                        onChange,
                        totalIndex,
                        compared: {
                            title: ['Room Nights 间夜数', `预算`],
                            record,
                            sqlName
                        }
                    };
                    return <TableText data={props} />
                }
            }, {
                title: `${month}月(实际)`,
                dataIndex: 'rn_actual',
                key: 'rn_actual',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "rn_actual",
                        onChange,
                        totalIndex,
                        compared: {
                            title: ['Room Nights 间夜数', `实际`],
                            record,
                            sqlName
                        }
                    };
                    return <TableText data={props} />
                }
            }]
        },
        {
            title: `Average Rate 平均房价`,
            children: [{
                title: `${month}月(预测)`,
                dataIndex: 'avg_forecast',
                key: 'avg_forecast',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "avg_forecast",
                        onChange,
                        totalIndex,
                        compared: {
                            title: ['Average Rate 平均房价', `预测`],
                            record,
                            sqlName
                        }
                    };
                    return <TableText data={props} />
                }
            }, {
                title: `${month}月(预算)`,
                dataIndex: 'avg_budget',
                key: 'avg_budget',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "avg_budget",
                        onChange,
                        totalIndex,
                        compared: {
                            title: ['Average Rate 平均房价', `预算`],
                            record,
                            sqlName
                        }
                    };
                    return <TableText data={props} />
                }
            }, {
                title: `${month}月(实际)`,
                dataIndex: 'avg_actual',
                key: 'avg_actual',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "avg_actual",
                        onChange,
                        totalIndex,
                        compared: {
                            title: ['Average Rate 平均房价', `实际`],
                            record,
                            sqlName
                        }
                    };
                    return <TableText data={props} />
                }
            }]
        },
        {
            title: `Room Revenue 客房收入`,
            children: [{
                title: `${month}月(预测)`,
                dataIndex: 'rev_forecast',
                key: 'rev_forecast',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "rev_forecast",
                        onChange,
                        totalIndex,
                        compared: {
                            title: ['Room Revenue 客房收入', `预测`],
                            record,
                            sqlName
                        }
                    };
                    return <TableText data={props} />
                }
            }, {
                title: `${month}月(预算)`,
                dataIndex: 'rev_budget',
                key: 'rev_budget',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "rev_budget",
                        onChange,
                        totalIndex,
                        compared: {
                            title: ['Room Revenue 客房收入', `预算`],
                            record,
                            sqlName
                        }
                    };
                    return <TableText data={props} />
                }
            }, {
                title: `${month}月(实际)`,
                dataIndex: 'rev_actual',
                key: 'rev_actual',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "rev_actual",
                        onChange,
                        totalIndex,
                        compared: {
                            title: ['Room Revenue 客房收入', `实际`],
                            record,
                            sqlName
                        }
                    };
                    return <TableText data={props} />
                }
            }]
        },
        {
            title: `REV Variance 整体收入差异`,
            children: [{
                title: `对比预测`,
                dataIndex: 'vsforecast',
                key: 'vsforecast',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "vsforecast",
                        onChange,
                        totalIndex,
                        compared: {
                            title: ['REV Variance 整体收入差异', `对比预测`],
                            record,
                            sqlName
                        }
                    };
                    return <TableText data={props} />
                }
            }, {
                title: `对比预算`,
                dataIndex: 'vsbudget',
                key: 'vsbudget',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "vsbudget",
                        onChange,
                        totalIndex,
                        compared: {
                            title: ['REV Variance 整体收入差异', `对比预算`],
                            record,
                            sqlName
                        }
                    };
                    return <TableText data={props} />
                }
            }]
        },
        {
            title: "Variance Explanation",
            align: "center",
            children: [{
                title: <div>落后或超出目标的主要原因</div>,
                dataIndex: 'note',
                key: 'note',
                align: "center",
                width: 300,
                render: (text, record, index) => {
                    const props = {
                        text,
                        index,
                        type: 'textArea',
                        name: "note",
                        onChange,
                        totalIndex,
                        minRows: 2,
                        compared: {
                            title: ['Variance Explanation', `落后或超出目标的主要原因`],
                            record,
                            sqlName
                        }
                    };
                    return <TableText data={props} />
                }
            },]
        }
    ]
}


// WEBPACK FOOTER //
// ./src/components/table/4new/4.2/4.2.1/diff/compute.js